export const MODAL_NEW_POLICY = 'modal-new-policy';
export const MODAL_POLICY_DETAILS = 'modal-policy-details';



// WEBPACK FOOTER //
// ./src/app/features/coverage/constants.ts